<template>
  <a-select
      v-model:value="state.value"
      :filter-option="false"
      :not-found-content="state.fetching ? undefined : null"
      :options="state.data"
      @search="fetchUser"
      v-bind="$attrs"
  >
    <template v-if="state.fetching" #notFoundContent>
      <a-spin size="small"/>
    </template>
  </a-select>
</template>
<script setup name="UnitSelect">
import {reactive, watch, watchEffect} from 'vue';
import {debounce} from 'lodash-es';

let lastFetchId = 0;

const emit = defineEmits(['getData'])
const props = defineProps({
  defaultOptions: {
    type: Array,
    default: () => []
  }
})
console.log('-------------unit-select')
console.log(props)

const state = reactive({
  data: props.defaultOptions || [], // 初始化时使用传入的默认选项
  value: [],
  fetching: false,
});
const fetchUser = debounce(async (value) => {
  console.log('fetching user', value);
  lastFetchId += 1;
  const fetchId = lastFetchId;
  state.data = [];
  state.fetching = true;

  emit('getData', value, (data) => {
    console.log('从父组件获取的返回值:', data)
    console.log(data)
    const setData = data.map(user => ({
      label: `${user.name}-${user.code}`,
      value: user.id,
    }));
    state.data = setData;
    state.fetching = false;
  })
  // fetch('https://randomuser.me/api/?results=5')
  //     .then(response => response.json())
  //     .then(body => {
  //       if (fetchId !== lastFetchId) {
  //         // for fetch callback order
  //         return;
  //       }
  //       const data = body.results.map(user => ({
  //         label: `${user.name.first} ${user.name.last}`,
  //         value: user.login.username,
  //       }));
  //       state.data = data;
  //       state.fetching = false;
  //     });
}, 300);

watch(state.value, () => {
  state.data = [];
  state.fetching = false;
});

// 监听默认选项变化
watchEffect(() => {
  if (props.defaultOptions && props.defaultOptions.length > 0) {
    state.data = props.defaultOptions;

    // 如果当前没有值，设置第一个选项为默认值
    if (!state.value && props.defaultOptions.length > 0) {
      state.value = props.defaultOptions[0].value;
    }
  }
});
</script>
